import BaseService from './BaseService';
import { camelizeKeys } from 'humps';
import _ from 'lodash';

const objectType = 'users';

class UsersService extends BaseService {

  static getList() {

    return super.get('/users?paginate=false')
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static create(data) {
    // to get around rails user.contracts
    data.contractingIds = data.contracts;

    return super.post(objectType, `/users`, _.omit(data, 'contracts'))
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {
    // to get around rails user.contracts
    data.contractingIds = data.contracts;

    return super.patch(objectType, `users/${data.id}`, _.omit(data, 'contracts'))
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super.delete(`users/${id}`)
      .then((response) => {
        return Promise.resolve({id});
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

}

export default UsersService;